import styled from 'styled-components';

export const Hamburger = styled.img.attrs({
  src: '/images/hamburger.svg',
})`
  cursor: pointer;
  margin: 10px 0;
`;
